/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */
function huraGetCookie(r){for(var t=r+"=",e=document.cookie.split(";"),n=0;n<e.length;n++){for(var i=e[n];" "==i.charAt(0);)i=i.substring(1);if(0==i.indexOf(t))return i.substring(t.length,i.length)}return ""}
function huraSetCookie(e,t,i){var o=new Date;o.setTime(o.getTime()+24*i*60*60*1e3);var n="expires="+o.toUTCString();document.cookie=e+"="+t+";"+n+";path=/"}

HuraScript = function($){
  if( $('#age-verification-popup').length > 0 ){
    var open_age_verification_popup=huraGetCookie('open-age-verification-popup');
    switch(open_age_verification_popup) {
      case '0':
        window.location.replace("/");
        break;
      case '1':
        $('body').css('opacity',1);
        break;
      default:
        $('body').css('opacity',1);
        $("#age-verification-popup").show();
    }  
    $(document).on('click touch','.hura-confirm-age-yes',function(){
      huraSetCookie('open-age-verification-popup',1);
      $("#age-verification-popup").hide();
      $('body').css('opacity',1);
    });

    $(document).on('click touch','.hura-confirm-age-no',function(){
      huraSetCookie('open-age-verification-popup',0);
      window.location.replace("/");    
    });
  }
  function huraAddToCartFail(jqXHR, textStatus, errorThrown){
    var response = $.parseJSON(jqXHR.responseText);
    alert(response.description);
  }
  function hura_buildCheckoutUrl() {
    function get_cookie(name){ return( document.cookie.match('(^|; )'+name+'=([^;]*)')||0 )[2] }
    do { token=get_cookie('cart'); }
    while(token == undefined);
    var myshopify_domain='dailyjocks-au.myshopify.com'
    try { var ga_linker = ga.getAll()[0].get('linkerParam') } catch(err) { var ga_linker ='' }
    var checkout_url= "https://checkout.rechargeapps.com/r/checkout?myshopify_domain="+myshopify_domain+"&cart_token="+token+"&"+ga_linker;
    return checkout_url;
  }
  function hura_reloadCartDrawer(){    
    $.getJSON('/cart', function (cart) {
      var CartDrawer = new theme.CartDrawer();
      CartDrawer.buildCart(cart,true);
    });
    $('.article-look-add-all-btn').removeAttr("disabled").removeClass('btn--loading');
  }
  function hura_addListToCart(items,qtys){
    if(items.length > 0){
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data:	{quantity: qtys[0], id: items[0]},
        dataType: 'json',
        error: huraAddToCartFail,
        success: function(){
          items.splice(0, 1);
          qtys.splice(0, 1);
          if(items.length == 0){
            hura_reloadCartDrawer();
          }else{
            hura_addListToCart(items,qtys); // Recall
          }
        }
      });
    }else{
      hura_reloadCartDrawer();
    }
  }
  $(document).ready(function(){

    /*
    if( $('.product-size-guide-btn').length ){
      $('head').append('<link rel="stylesheet" type="text/css" href="//cdn.jsdelivr.net/npm/featherlight@1.7.14/release/featherlight.min.css">');
      $.getScript("//cdn.jsdelivr.net/npm/featherlight@1.7.14/release/featherlight.min.js").done(function(){      
        $('.product-size-guide-btn').on('click', function(){$.featherlight($('#size-guide-modal'));});
      });
    }

    if( $('.product-discreet-packaging-btn').length ){
      $('head').append('<link rel="stylesheet" type="text/css" href="//cdn.jsdelivr.net/npm/featherlight@1.7.14/release/featherlight.min.css">');
      $.getScript("//cdn.jsdelivr.net/npm/featherlight@1.7.14/release/featherlight.min.js").done(function(){      
        $('.product-discreet-packaging-btn').on('click', function(){$.featherlight($('#discreet-packaging-modal'));});
      });
    }
    */

    $(".look-book-slider").each(function(){
      var imageCount = $(this).find('img').length;
      $(this).slick({
        autoplay: false,
        arrows: false,
        dots: false,
        slidesToShow: Math.min(3, imageCount-1),
        responsive: [
          {
            breakpoint: 600,
            settings: {
              arrows: false,
              slidesToShow: 1
            }
          }
        ]
      });
    });

    //Artile Lookbook
    $(document).on("change",".single-option-selector",function(){
      var $wrapper = $(this).closest('.product-look-item');
      var option = $(this).val();
      $wrapper.find('option').each(function(){
        if( option == $(this).data('option1') ){
          if( $(this).data('available')){
            var text_addtocart = 'Add to cart';
            $wrapper.find('.product-form__cart-submit').removeAttr("disabled").find('span span').html(text_addtocart);
          }else{
            var text_soldout = 'Sold out';
            $wrapper.find('.product-form__cart-submit').attr("disabled","disabled").find('span span').html(text_soldout);            
          }
          $wrapper.find('.product__price span').html( $(this).data('price') );
          $wrapper.find('.hura-single__variants').val( $(this).attr('value') ).change();
        }
      });
    });

    $('.product-look-item form').submit(function(e){
      e.preventDefault();
      var $form = $(this);
      $form.find('.product-form__cart-submit').attr("disabled","disabled").addClass('btn--loading');
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data:	$form.serialize(),
        dataType: 'json',
        error: huraAddToCartFail        
      }).done(function(data){
        hura_reloadCartDrawer();
        $form.find('.product-form__cart-submit').removeAttr("disabled").removeClass('btn--loading');
      });
    });

    $(document).on('click','.article-look-add-all-btn',function(e){
      $(this).attr("disabled","disabled").addClass('btn--loading');
      var variants = [];
      var quantities = [];
      $('.product-look-item form').each(function(){
        variants.push( $(this).find('.hura-single__variants').val() );
        quantities.push( $(this).find('.product-form__quantity').val() );
      });      
      hura_addListToCart(variants.reverse(),quantities.reverse());      
    });


    //Subscription Page
    $(document).on('click','.cart__checkout, .cart__checkout-button, .checkout-button',function(e){
      e.preventDefault();
      $.getJSON('/cart', function (results) {
        var checkout_url = '/checkout';
        var is_subscription = false;
        var discount = '';
        
        let ids = []; 
        let qtys = [];
        let pties = [];
        $.each(results.items, function (i, item) {
          if(item.properties!== null){
            $.each(item.properties, function (j, property) {
              if(j=='shipping_interval_frequency'){ is_subscription = true; }
              if(j=='_recurring-discount-code'){ discount=property}
            });            
          }
          ids.push(item.variant_id); 
          qtys.push(item.quantity);
          pties.push(item.properties);
        });
        if( is_subscription ) checkout_url=hura_buildCheckoutUrl();
        if( discount!='' ) checkout_url = hura_buildCheckoutUrl()+'&discount='+discount;
        if( checkout_url == '/checkout' ){
          window.location.replace( checkout_url );
        }else{
          if( window.themeVariables.routes.host != 'dailyjocks.com.au' ){
            //Handle cart to AU site
            ids = encodeURI(JSON.stringify(ids));
            qtys = encodeURI(JSON.stringify(qtys));
            pties = encodeURI(JSON.stringify(pties));
            let param = '&host='+window.themeVariables.routes.host+'&id='+ids+'&qty='+qtys+'&code='+discount+'&pty='+pties
            window.location.replace( 'https://dailyjocks.com.au/cart?view=checkout'+param );
            //window.location.replace( checkout_url );
          }else{
            window.location.replace( checkout_url );
          }
        }        
      });
    });

    $(document).on('click','.hura-subscription-page .value', function(){
      var $option = $(this).closest('.option');
      $option.find('.value').removeClass('active');
      $(this).addClass('active');      
    });

    $(document).on('click','.hura-subscription-page .shipping-frequency .value', function(){
      setTimeout(function(){
        //$('.hura-subscription-page .payment-frequency .value').removeClass('active');
        var shipping_frequency = $('.shipping-frequency .value.active').data('title');
        $('.hura-subscription-page .payment-frequency .unit font').text(shipping_frequency);   
        $('.hura-subscription-page .payment-frequency .unit').attr('data-title',shipping_frequency);        
        $('.payment-frequency .bottom-title').each(function(){          
          $(this).html( $(this).data('ship-'+shipping_frequency) );           
        });
      }, 50);
    });

    $(document).on('click','.hura-subscription-submit', function(){

      var $button = $(this);
      var buttonText = $(this).html();

      var option_1 = $('.option-1 .value.active').data('title');
      if(option_1===undefined){ alert('Please choose a type of First Preference!'); return false;}
      var option_2 = $('.option-2 .value.active').data('title');
      if(option_2===undefined){ alert('Please choose a type of Seconds Preference!'); return false;}
      var option_3 = $('.option-3 .value.active').data('title');
      if(option_3===undefined){ alert('Please choose a size!'); return false;}

      var payment_frequency = $('.payment-frequency .value.active').data('title');
      payment_frequency = 1;
      if(payment_frequency===undefined){ alert('Please select a payment frequency!'); return false;}
      var shipping_frequency = $('.shipping-frequency .value.active').data('title');
      shipping_frequency = 1;
      if(shipping_frequency===undefined){ alert('Please select a shipping frequency!'); return false;}

      $button.attr("disabled","disabled").html('ADDING...');

      var variant_title = option_1 +' / '+ option_2 +' / '+ option_3;
      var recurring_discount_code = 'FIRSTORDER';

      var variant_id = 0;
      var subscription_id= '';

      $.get( '/collections/_subscriptions?view=subscriptions-json' ).done(function(subproducts){
        var subproducts = $.parseJSON(subproducts);  
        var product_handle = 'mix-of-brands-subscription';
        if( payment_frequency != '1' && payment_frequency != '2' ){
          recurring_discount_code = 'FIRSTORDER_'+shipping_frequency+'-'+payment_frequency;
          product_handle = 'mix-of-brands-prepaid-ship-every-'+shipping_frequency+'-month-paid-every-'+payment_frequency;
          if(shipping_frequency!='1'){            
            product_handle = 'mix-of-brands-prepaid-ship-every-'+shipping_frequency+'-months-paid-every-'+payment_frequency;
          }
        }
        $.each( subproducts, function( i, subproduct ) {
          if(subproduct.handle == product_handle){
            $.each( subproduct.variants, function( j, variant ) {
              if(variant.title == variant_title){
                variant_id = variant.id;
                subscription_id = (subproduct.subscription_id === null)?'':subproduct.subscription_id;
              }
            });
          }
        });

        if(variant_id!=0){
          var properties = {'subscription_id': subscription_id, 'shipping_interval_unit_type': 'Months', 'shipping_interval_frequency': shipping_frequency, 'product_note':'', '_recurring-discount-code':recurring_discount_code,'_payment_frequency':payment_frequency};
          
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {quantity:1, id:variant_id, properties:properties},
            dataType: 'json',
            error: huraAddToCartFail,
          }).done(function(){
            window.location.replace('/cart');            
          });
        }else{
          alert('Couldn\'t be added to cart.');          
          $button.removeAttr("disabled").html(buttonText);          
        }
      });
    });
  });
  function huraScrollProductMedia(){
    let header_height = $('store-header').height()+15;
    let _css = '';
    _css += '@media screen and (min-width: 1000px){';
    _css += '.shopify-section--main-product product-media{position:sticky;top:'+header_height+'px;}';
    _css += '.shopify-section--main-product product-media.hura-original{position:relative;}';
    _css += '}';
    if( $( '#huraScrollProductMedia' ).length > 0 ){
      $('#huraScrollProductMedia').html(_css);
    }else{      
      $('head').append('<style id="huraScrollProductMedia">'+_css+'</style>');
    }
    $(document).on('click touch','.pswp__button--close',function(){
      $('.shopify-section--main-product product-media').removeClass('hura-original');
    });
    $(document).on('click touch','.product__zoom-button',function(){
      $('.shopify-section--main-product product-media').addClass('hura-original');
    });
  }
  if(meta.page.pageType=='product'){
    huraScrollProductMedia();
    $( window ).resize(function() {
      huraScrollProductMedia();
    });
  }
}

var jqHuraScript = document.createElement('script');
jqHuraScript.setAttribute("src", "https://ajax.googleapis.com/ajax/libs/jquery/3.1.0/jquery.min.js");
jqHuraScript.setAttribute("type", "text/javascript");

if (jqHuraScript.readyState) {
  jqHuraScript.onreadystatechange = function () {
    if (this.readyState == 'loaded' || this.readyState == 'complete') {
      HuraScript(jQuery.noConflict(true));
    }
  };
} else {
  jqHuraScript.onload = function () {
    HuraScript(jQuery.noConflict(true));
  };
}
var d = document.getElementsByTagName("head")[0] || document.documentElement;
d.appendChild(jqHuraScript);

//Infinite Scroll  - Coded by HuynhMaiAnhKiet@Gmail.Com - HuraApps.Com
//ajaxinate.js
"use strict";var Ajaxinate=function(e){var i=e||{},n={pagination:".AjaxinatePagination",method:"scroll",container:".AjaxinateLoop",offset:0,loadingText:"Loading",callback:null};this.settings=Object.assign(n,i),this.addScrollListeners=this.addScrollListeners.bind(this),this.addClickListener=this.addClickListener.bind(this),this.checkIfPaginationInView=this.checkIfPaginationInView.bind(this),this.stopMultipleClicks=this.stopMultipleClicks.bind(this),this.destroy=this.destroy.bind(this),this.containerElement=document.querySelector(this.settings.container),this.paginationElement=document.querySelector(this.settings.pagination),this.initialize()};Ajaxinate.prototype.initialize=function(){if(this.containerElement){var e={click:this.addClickListener,scroll:this.addScrollListeners};e[this.settings.method]()}},Ajaxinate.prototype.addScrollListeners=function(){this.paginationElement&&(document.addEventListener("scroll",this.checkIfPaginationInView),window.addEventListener("resize",this.checkIfPaginationInView),window.addEventListener("orientationchange",this.checkIfPaginationInView))},Ajaxinate.prototype.addClickListener=function(){this.paginationElement&&(this.nextPageLinkElement=this.paginationElement.querySelector("a"),this.clickActive=!0,this.nextPageLinkElement!==null&&this.nextPageLinkElement.addEventListener("click",this.stopMultipleClicks))},Ajaxinate.prototype.stopMultipleClicks=function(e){e.preventDefault(),this.clickActive&&(this.nextPageLinkElement.innerHTML=this.settings.loadingText,this.nextPageUrl=this.nextPageLinkElement.href,this.clickActive=!1,this.loadMore())},Ajaxinate.prototype.checkIfPaginationInView=function(){var e=this.paginationElement.getBoundingClientRect().top-this.settings.offset,i=this.paginationElement.getBoundingClientRect().bottom+this.settings.offset;e<=window.innerHeight&&i>=0&&(this.nextPageLinkElement=this.paginationElement.querySelector("a"),this.removeScrollListener(),this.nextPageLinkElement&&(this.nextPageLinkElement.innerHTML=this.settings.loadingText,this.nextPageUrl=this.nextPageLinkElement.href,this.loadMore()))},Ajaxinate.prototype.loadMore=function(){this.request=new XMLHttpRequest,this.request.onreadystatechange=function(){if(this.request.readyState===4&&this.request.status===200){var i=this.request.responseXML.querySelectorAll(this.settings.container)[0],n=this.request.responseXML.querySelectorAll(this.settings.pagination)[0];this.containerElement.insertAdjacentHTML("beforeend",i.innerHTML),this.paginationElement.innerHTML=n.innerHTML,this.settings.callback&&typeof this.settings.callback=="function"&&this.settings.callback(this.request.responseXML),this.initialize()}}.bind(this),this.request.open("GET",this.nextPageUrl),this.request.responseType="document",this.request.send()},Ajaxinate.prototype.removeClickListener=function(){this.nextPageLinkElement.addEventListener("click",this.stopMultipleClicks)},Ajaxinate.prototype.removeScrollListener=function(){document.removeEventListener("scroll",this.checkIfPaginationInView),window.removeEventListener("resize",this.checkIfPaginationInView),window.removeEventListener("orientationchange",this.checkIfPaginationInView)},Ajaxinate.prototype.destroy=function(){var e={click:this.removeClickListener,scroll:this.removeScrollListener};return e[this.settings.method](),this};
var loading_img = "//cdn.shopify.com/s/files/1/0074/1418/6039/t/41/assets/ajax-load.gif";
function callbackInfiniteScroll(){
  let list_items = document.querySelectorAll("#hura-product-loop product-item");
  list_items.forEach( (item) => {
   item.style.opacity=1;
  });
  document.getElementById('current_products_count').innerHTML = list_items.length;  
}
document.addEventListener("DOMContentLoaded", function() {
  var endlessScroll = new Ajaxinate({
    container: '#hura-product-loop',
    pagination: '#hura-pagination',
    loadingText: '<center><img src="'+loading_img+'"></center>',
    method: 'click',
    callback: callbackInfiniteScroll
  });
});
